import { render, staticRenderFns } from "./somaterialissue.vue?vue&type=template&id=1b860fce&scoped=true&"
import script from "./somaterialissue.vue?vue&type=script&lang=js&"
export * from "./somaterialissue.vue?vue&type=script&lang=js&"
import style0 from "./somaterialissue.vue?vue&type=style&index=0&id=1b860fce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b860fce",
  null
  
)

export default component.exports